import type { MenuMode } from '@/hooks/usePlayer';

export const paths = {
  music: () => '/music',
  musicRelease: (id: string) => `/music/${encodeURIComponent(id)}`,
  /** Deep-link a track within a release (onesheet / share). */
  musicReleaseTrack: (id: string, position: number) =>
    `/music/${encodeURIComponent(id)}?track=${encodeURIComponent(String(position))}`,
  /** Boot into shared live radio. */
  musicLive: () => '/music?live=1',
  photo: () => '/photo',
  photoPost: (id: string) => `/photo/${encodeURIComponent(id)}`,
  info: () => '/info',
  settings: () => '/settings',
} as const;

export type AppRoute = {
  mode: MenuMode;
  id: string | null;
};

/** Parse pathname into catalog mode + optional selected id. */
export function parseAppPath(pathname: string): AppRoute {
  const path = pathname.replace(/\/+$/, '') || '/';

  if (path === '/settings' || path.startsWith('/settings/')) {
    return { mode: 'settings', id: null };
  }

  if (path === '/info' || path.startsWith('/info/')) {
    return { mode: 'info', id: null };
  }

  if (path === '/photo') {
    return { mode: 'photo', id: null };
  }
  const photoMatch = path.match(/^\/photo\/([^/]+)$/);
  if (photoMatch) {
    return { mode: 'photo', id: decodeURIComponent(photoMatch[1]!) };
  }

  if (path === '/music' || path === '/') {
    return { mode: 'music', id: null };
  }
  const musicMatch = path.match(/^\/music\/([^/]+)$/);
  if (musicMatch) {
    return { mode: 'music', id: decodeURIComponent(musicMatch[1]!) };
  }

  return { mode: 'music', id: null };
}
